import { lazy } from 'react';

export const GymSummaryProgress = lazy(() =>
  import('./progress/GymSummaryProgress').then((m) => ({
    default: m.GymSummaryProgress,
  })),
);

export const JtfSummaryProgress = lazy(() =>
  import('./progress/JtfSummaryProgress').then((m) => ({
    default: m.JtfSummaryProgress,
  })),
);

export const KsSummaryProgress = lazy(() =>
  import('./progress/KsSummaryProgress').then((m) => ({
    default: m.KsSummaryProgress,
  })),
);

export const SkillSetSummaryProgress = lazy(() =>
  import('./progress/SkillSetSummaryProgress').then((m) => ({
    default: m.SkillSetSummaryProgress,
  })),
);

export const VifSummaryProgress = lazy(() =>
  import('./progress/VifSummaryProgress').then((m) => ({
    default: m.VifSummaryProgress,
  })),
);

export const FluencyGamesReportView = lazy(() =>
  import('./reports/FluencyGamesReportView').then((m) => ({
    default: m.FluencyGamesReportView,
  })),
);
